import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    width: '100%',
    marginTop: theme.spacing(1),

    '& .recharts-wrapper *': {
      outline: 'none !important',
    },
  },
}));
